@if (isDemo) {
    <div class="demo-banner">
        <img src="assets/icons/demo-icon-banner.svg" alt="Demo mode icon" class="demo-icon" />
        <span class="demo-text">Demo mode</span>
    </div>
}
<section class="page" data-testid="auth-page">
    <div class="main-container">
        <img src="assets/logo/aw_logo.svg" alt="Airwallet logo" class="logo" width="90" height="18" />
        <div class="sign-in-and-signup-card">
            <div class="sign-in-and-signup-card-inner">
                @if (isUnderMaintenance()) {
                    <div class="card-view mb-3 mt-3 p-3 text-center" animate.enter="aw-fade-in">
                        <h2>{{ "sign-in.maintenance" | translate }}</h2>
                        <p>{{ "sign-in.back_at" | translate }}</p>
                        <p>{{ getFormattedBackAt() }}</p>
                    </div>
                } @else if (!showLoad) {
                    <div class="card-view" [class.card-view--pending]="maintenanceService.checkingForMaintenance()" animate.leave="aw-fade-out">
                        <div class="animation-outer title">
                            @if (authPageService.isMfaTotpSignIn() || authPageService.isMfaPhoneSignIn()) {
                                <h2 class="sign-in-title animation-inner" animate.enter="aw-fade-in" animate.leave="aw-fade-out">
                                    {{ "account.mfa.auth_code" | translate }}
                                    @if (authPageService.isMfaPhoneSignIn()) {
                                        <span>{{ "misc.sms_capitalized" | translate }}</span>
                                    }
                                </h2>
                            } @else if (view() === "sign-in") {
                                <h2 class="sign-in-title animation-inner" animate.enter="aw-fade-in" animate.leave="aw-fade-out">
                                    {{ "sign-in.sign_in_to_acc" | translate }}
                                </h2>
                            } @else {
                                @if (isDemo && this.authPageService.loading()) {
                                    @if (this.authPageService.displayAlmostDone()) {
                                        <h2 class="sign-in-title animation-inner" animate.enter="aw-fade-in" animate.leave="aw-fade-out">
                                            <p>{{ "sign_up.almost_done_creating_demo_acc" | translate }}</p>
                                        </h2>
                                    } @else {
                                        <h2 class="sign-in-title animation-inner" animate.enter="aw-fade-in" animate.leave="aw-fade-out">
                                            <p>{{ "sign_up.creating_demo_acc" | translate }}</p>
                                        </h2>
                                    }
                                } @else {
                                    <h2 class="sign-in-title animation-inner" animate.enter="aw-fade-in" animate.leave="aw-fade-out">
                                        {{ "sign_up.sign_up_for_aw" | translate }}
                                    </h2>
                                }
                            }
                        </div>

                        <div class="form-container" [ngStyle]="{ overflow: isTransitioning() ? 'hidden' : 'visible' }" [ngClass]="animationView()">
                            @if (view() === "sign-in") {
                                <app-sign-in class="inner-view" />
                            } @else {
                                <app-sign-up class="inner-view" />
                            }
                        </div>

                        <app-aw-button class="submit-button" buttonId="submit-button" dataTestId="auth-submit-button" [loading]="authPageService.loading()" size="large" (clickEmitter)="handleSubmit()">
                            <span button-content>
                                {{ (authPageService.isMfaTotpSignIn() ? "account.mfa.verify" : view() === "sign-in" ? "sign-in.sign_in" : "sign_up.sign_up") | translate }}
                            </span>
                        </app-aw-button>

                        <div class="end-container">
                            <div class="hr"></div>
                            <div class="sso">
                                <div class="sso-button" id="sso-button">
                                    @if (authPageService.loadingSamlLogin()) {
                                        <app-loading-indicator size="small" color="secondary"></app-loading-indicator>
                                    } @else {
                                        <span (click)="signInWithSAML()" data-testid="auth-page-saml-sso-button">
                                            <img src="assets/icons/sso/entra_id.svg" alt="Entra ID logo" class="sso-icon" />
                                            <u>
                                                <span>{{ "sign-in.continue_saml_sso" | translate }}</span>
                                            </u>
                                            <img class="arrow-right" src="assets/icons/arrow-right.svg" alt="arrow-right" />
                                        </span>
                                    }
                                </div>
                            </div>
                            <div class="animation-outer">
                                @if (authPageService.isMfaTotpSignIn() || authPageService.isMfaPhoneSignIn()) {
                                    <button class="sign-up-link animation-inner" [disabled]="authPageService.loading()" (click)="goBack()" tabindex="-1" animate.enter="aw-fade-in" animate.leave="aw-fade-out" data-testid="auth-page-go-back-button">
                                        {{ "location.go_back" | translate }}
                                    </button>
                                } @else if (view() === "sign-in") {
                                    <button class="sign-up-link animation-inner" [disabled]="authPageService.loading()" (click)="toggleAuthPage()" tabindex="-1" animate.enter="aw-fade-in" animate.leave="aw-fade-out" data-testid="auth-page-toggle-sign-up-button">
                                        {{ "sign-in.need_account" | translate }}
                                    </button>
                                } @else {
                                    @if (!authPageService.loading()) {
                                        <button class="sign-up-link animation-inner" [disabled]="authPageService.loading()" (click)="toggleAuthPage()" tabindex="-1" animate.enter="aw-fade-in" animate.leave="aw-fade-out" data-testid="auth-page-toggle-sign-in-button">
                                            {{ "sign-in.already_have_acc" | translate }}
                                        </button>
                                    }
                                }
                            </div>

                            <p class="support-call">
                                {{ "misc.need_help" | translate }}
                                <br />
                                <span>
                                    {{ "misc.US" | translate }} <a href="{{ supportPhone.us.telLink }}" tabindex="-1" data-testid="auth-page-support-us-link">{{ supportPhone.us.phoneNumber }}</a>
                                </span>
                                <br />
                                <span>
                                    {{ "misc.other" | translate }} <a href="{{ supportPhone.main.telLink }}" tabindex="-1" data-testid="auth-page-support-main-link">{{ supportPhone.main.phoneNumber }}</a>
                                </span>
                            </p>
                        </div>
                    </div>
                }

                @if (showLoad) {
                    <div>
                        <app-loading-indicator [size]="'large'" [color]="'primary'"></app-loading-indicator>
                    </div>
                }
            </div>
        </div>
    </div>
    <p class="version-text">{{ "sign-in.version" | translate }}{{ version }}</p>
</section>
<ng-lottie [options]="options" class="lottie-waves"></ng-lottie>
